angular.module('unica_workshop_session.workshop_session_controllers')

.controller('WorkshopSessionEditController', function(
	$rootScope, $scope, $state, $stateParams,
	WorkshopSessionEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getWorkshop( $stateParams.workshop_id );

	$rootScope.getWorkshopSession( $stateParams.id );

	$scope.$on( 'workshopData_loaded', function() {
		$rootScope.getEventStages( $stateParams.event_id );
	})

	$scope.days = [];
	$scope.$on( 'stages_loaded', function() {

		angular.forEach( $rootScope.stages, function(st) {

			if ( $rootScope.workshopSessionData.free_seats ){
				$rootScope.workshopSessionData.seats = undefined;
			}

			if ( st.id == $rootScope.workshopData.stage_id ) {

				st['from_date'].setHours(0);
				st['to_date'].setHours(23);

				var fdM  = moment( st['from_date'], 'DD-MM-YYYY' ),
					tdM  = moment( st['to_date'],   'DD-MM-YYYY' ),
					diff = tdM.diff( fdM, 'days'),
					i    = 0;

				// Starting day
				$scope.days.push( fdM.format('DD/MM/YYYY') );

				for ( ; i < diff; i++ ) {
					$scope.days.push( fdM.add('days', 1).format('DD/MM/YYYY') );
				}

			}

		});

	});

	$rootScope.workshopSessionData = {
		workshop_id: $stateParams.workshop_id,
	};

	$scope.saveWorkshopSession = function() {
		$scope.showLoader();

		var workshopSessionData = angular.copy($rootScope.workshopSessionData);
		workshopSessionData = $scope.parseWorkshopSessionFromDateToTimestamp(workshopSessionData);

		if ( workshopSessionData.from_time >= workshopSessionData.to_time ){
			$scope.showErrorMsg('Ora fine non successiva a ora inizio!');
			$scope.hideLoader();
			return;
		}

		WorkshopSessionEditService
			.update( workshopSessionData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Sessione Workshop aggiornata con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});

	};

});
